<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <app-ion-common-label
    [id]="idLabelName"
    class="document-type-label1"
    labelStyle="display-rg"
    labelDescription="{{
      nameNative ? nameNative + ', ' : ''
    }}qual é o seu nome completo?"
  >
  </app-ion-common-label>

  <div class="conent-center conent-center--mrt-lg">
    <form [formGroup]="nameForm" (ngSubmit)="submitForm($event)">
      <app-ion-common-input
        [placeholder]="placeholder"
        [error]="error"
        [id]="idComponentName"
        [textError]="textError"
        [maxLength]="maxLength"
        (textChange)="setValueInput($event, 'docName')"
        type="text"
        [fieldValue]="name"
        [idLabel]="idLabel"
        [replaceStrTo]="'nameV2'"
        [label]="label"
        name="docName"
        [disabled]="!this.edit"
        formControlName="docName"
        ngDefaultControl
      >
      </app-ion-common-input>
    </form>
  </div>
  <app-ion-common-button
    [id]="idButtonName"
    class="hidden"
    [ngClass]="{ hidden: !buttonEnable || name.length === 0 }"
    [attr.aria-hidden]="!buttonEnable"
    (clickButton)="clickNext()"
    label="Continuar"
  ></app-ion-common-button>
</ion-content>
